"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _checkDispatchValue = _interopRequireDefault(require("./check-dispatch-value"));

var _runSideEffect = _interopRequireDefault(require("./run-side-effect"));

var _processDispatchValue = _interopRequireDefault(require("./process-dispatch-value"));

var _runReducerActions = _interopRequireDefault(require("./run-reducer-actions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var runMiddleware = function runMiddleware(middlewareData) {
  var doesDispatchValuePass = (0, _checkDispatchValue["default"])(middlewareData);
  (0, _runSideEffect["default"])(middlewareData, 'log');

  if (doesDispatchValuePass) {
    (0, _runSideEffect["default"])(middlewareData, 'run');
    var dispatchValue = (0, _runReducerActions["default"])(middlewareData);
    middlewareData = _objectSpread(_objectSpread({}, middlewareData), {}, {
      dispatchValue: dispatchValue
    });
    var processedDispatchValue = (0, _processDispatchValue["default"])(middlewareData);

    if (_processDispatchValue["default"] !== dispatchValue) {
      middlewareData = _objectSpread(_objectSpread({}, middlewareData), {}, {
        dispatchValue: processedDispatchValue
      });
    }

    (0, _runSideEffect["default"])(middlewareData, 'callback');
    return middlewareData.dispatchValue;
  }

  return null;
};

var _default = runMiddleware;
exports["default"] = _default;
module.exports = exports.default;